import React from 'react';
import Image from 'next/image';
import image1 from '@/public/images/testimonals/image-page-1.webp';
import image2 from '@/public/images/testimonals/image-page-2.webp';
import image3 from '@/public/images/testimonals/image-page-3.webp';
import image4 from '@/public/images/testimonals/image-page-4.webp';
import image5 from '@/public/images/testimonals/image-page-5.webp';
import image6 from '@/public/images/testimonals/image-page-6.webp';

export const Testimonials = () => {
  return (
    <div>
      <p className="mb-8 text-lg font-normal">
        At Tytum, our commitment to top-quality services and excellent customer
        care shines through in every project. With over 20 years of experience,
        we proudly serve the Greater San Diego Area, including East County,
        Central San Diego, North County, and South Bay.
      </p>
      <p className="mb-8 text-lg font-normal">
        Our customers’ satisfaction is our top priority. Here’s what some of our
        clients have to say about their experiences with us:
      </p>
      <ul className="mb-10">
        <li className="flex justify-start">
          <Image src={image3} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>
        <li className="flex justify-end">
          <Image src={image2} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>
        <li className="flex justify-start">
          <Image src={image1} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>
        <li className="flex justify-end">
          <Image src={image4} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>
        <li className="flex justify-start">
          <Image src={image5} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>

        <li className="flex justify-end">
          <Image src={image6} alt="testimonials" className="mb-5 rounded-3xl" />
        </li>
      </ul>
      <p className="mb-8 text-lg font-normal">
        At Tytum, we’re dedicated to providing the best in heating, air
        conditioning, electrical, plumbing, remodeling, and real estate
        services.
      </p>
      <p className="mb-8 text-lg font-normal">
        Contact us today to experience the Tytum difference for yourself!
      </p>
    </div>
  );
};
